import React, { useEffect } from 'react';
import { CheckCircle, X, AlertCircle, Info, AlertTriangle } from 'lucide-react';

function Toast({ message, type = 'success', onClose, duration = 6000 }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const config = {
    success: {
      icon: CheckCircle,
      bgColor: '#d1fae5',
      borderColor: '#10b981',
      textColor: '#065f46',
      iconColor: '#10b981'
    },
    error: {
      icon: AlertCircle,
      bgColor: '#fee2e2',
      borderColor: '#ef4444',
      textColor: '#991b1b',
      iconColor: '#ef4444'
    },
    warning: {
      icon: AlertTriangle,
      bgColor: '#fef3c7',
      borderColor: '#f59e0b',
      textColor: '#92400e',
      iconColor: '#f59e0b'
    },
    info: {
      icon: Info,
      bgColor: '#dbeafe',
      borderColor: '#3b82f6',
      textColor: '#1e40af',
      iconColor: '#3b82f6'
    }
  };

  const currentConfig = config[type];
  const Icon = currentConfig.icon;

  return (
    <div
      style={{
        position: 'fixed',
        top: '5rem',
        right: '1.5rem',
        zIndex: 9999,
        backgroundColor: currentConfig.bgColor,
        border: `2px solid ${currentConfig.borderColor}`,
        borderRadius: '0.75rem',
        padding: '1rem 1.25rem',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        minWidth: '300px',
        maxWidth: '400px',
        animation: 'slideIn 0.3s ease-out'
      }}
    >
      <Icon size={24} color={currentConfig.iconColor} style={{ flexShrink: 0 }} />
      <p style={{
        margin: 0,
        color: currentConfig.textColor,
        fontFamily: '"Noto Sans", sans-serif',
        fontSize: '0.9375rem',
        fontWeight: '500',
        flex: 1
      }}>
        {message}
      </p>
      <button
        onClick={onClose}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '0.25rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: currentConfig.textColor,
          opacity: 0.7,
          transition: 'opacity 200ms'
        }}
        onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
        onMouseLeave={(e) => e.currentTarget.style.opacity = 0.7}
      >
        <X size={18} />
      </button>

      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}

export default Toast;